export default "__VITE_ASSET__B0f_6vol__"